import { compose, prop } from 'ramda';

const PATH_FILENAME_PATTERN = /^(.+[\\/]+)?([^\\/]+)$/;

export const splitPathAndFileName = (path) => {
    const match = path.match(PATH_FILENAME_PATTERN);

    if (!match) {
        throw new Error(`Invalid path: ${path}`);
    }

    return {
        path: match[1] ?? '',
        fileName: match[2],
    };
};

export const getLastSegment = compose(prop('fileName'), splitPathAndFileName);

const INVALID_NAME_CHARS = /[/:*?"<>|]/;

export const testFileName = (fileName) => {
    if (INVALID_NAME_CHARS.test(fileName)) {
        throw new Error(
            'Filename can\'t contain any of the following characters: \\ / : * ? " < > |',
        );
    }
};
